import {
  CircularProgress,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
  List,
  ListItemText,
} from "@mui/material";
import MDBox from "components/MDBox";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";
import React from "react";

export default function PickerList({
  title,
  loading,
  empty,
  header,
  footer,
  onClose,
  children,
}: {
  title: string;
  loading: boolean;
  empty: boolean;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  onClose?: () => void;
  children: React.ReactNode;
}) {
  let content: React.ReactNode;

  if (loading) {
    content = (
      <MDBox display="flex" justifyContent="center" py="32px">
        <CircularProgress size={24} />
      </MDBox>
    );
  } else if (empty) {
    content = (
      <MDBox
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap="6px"
        py="32px"
        sx={{ color: draftColors.textSecondary }}
      >
        <Icon>inventory_2</Icon>
        <ListItemText
          primary="No library items found"
          primaryTypographyProps={{ fontSize: "12px", textAlign: "center" }}
        />
      </MDBox>
    );
  } else {
    content = (
      <List
        dense
        sx={{
          py: 0,
          "& .MuiListItemButton-root": {
            minHeight: 34,
            px: "8px",
            py: "2px",
            borderRadius: "6px",
          },
          "& .MuiListItemButton-root:hover": {
            backgroundColor: draftColors.surfaceMuted,
          },
          "& .MuiListItemButton-root.Mui-selected": {
            backgroundColor: `${draftColors.surfaceMuted} !important`,
          },
          "& .MuiListItemText-primary": { fontSize: "13px", fontWeight: 500 },
          "& .MuiListItemText-secondary": { fontSize: "11px" },
          "& .MuiCheckbox-root": { p: "4px", mr: "2px" },
        }}
      >
        {children}
      </List>
    );
  }

  return (
    <>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: "15px",
          fontWeight: 600,
          px: "16px",
          py: "10px",
          borderBottom: `1px solid ${draftColors.border}`,
        }}
      >
        {title}
        {onClose && (
          <IconButton size="small" aria-label="Close" onClick={onClose} sx={{ p: "2px" }}>
            <Icon sx={{ fontSize: 18 }}>close</Icon>
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent sx={{ px: "16px", pb: "12px", pt: "12px" }}>
        {header}
        {content}
      </DialogContent>
      {footer}
    </>
  );
}
